// extracted by mini-css-extract-plugin
export default {"bottomNav":"BottomNav_bottomNav__mGB62","navItem":"BottomNav_navItem__niggC","active":"BottomNav_active__a4ZRj","icon":"BottomNav_icon__zrt9G","label":"BottomNav_label__SrwKu"};